import React from 'react';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
var CourseParameter = function (_a) {
    var item = _a.item;
    return (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-w-1/4 lfc-h-10" },
        React.createElement("div", { className: "lfc-bg-[#F8F8FF] lfc-w-10 lfc-h-10 lfc-flex lfc-items-center lfc-justify-center lfc-text-blue-500 lfc-rounded lfc-mr-2" }, item.icon),
        React.createElement("span", null,
            React.createElement("div", { className: "lfc-text-xs lfc-text-gray-700 lfc-block" },
                item.title,
                ' ',
                !!item.infoText && (React.createElement(Tooltip, { title: item.infoText },
                    React.createElement(InfoOutlined, { sx: { color: '#8e8e8e', fontSize: '1rem' } })))),
            React.createElement("div", { className: "lfc-text-gray-900 lfc-text-sm lfc-font-medium lfc-block" }, item.value))));
};
export default CourseParameter;
//# sourceMappingURL=CourseParameter.js.map